import React, { useState } from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
  Typography,
  Box,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Colors } from "../../Theme/Theme";

const InputBox = ({
  usingInDarkMode,
  label,
  type,
  value,
  onChange,
  showPasswordToggle,
  required,
  error,
  helperText,
  name,
  onKeyDown,
  placeholder,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((prev) => !prev);

  return (
    <Box mb={"25px"} width={"100%"}>
      <Typography
        display={"flex"}
        marginRight={"auto"}
        mb={"5px"}
        fontSize={"12px"}
        sx={{ color: usingInDarkMode ? "#f2f2f2" : Colors.primaryTextColor, fontWeight: 500 }}
        className={'poppins-font'}
        >
        {label}
      </Typography>
      <TextField
        required={required}
        placeholder={placeholder}
        type={showPasswordToggle && showPassword ? "text" : type}
        name={name}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        variant="outlined"
        fullWidth
        error={error}
        helperText={helperText}
        InputProps={
          showPasswordToggle
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleClickShowPassword} edge="end" size="small">
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : undefined
        }
        sx={{
          "& .MuiInputBase-root": {
            fontFamily: "inherit",
            color: usingInDarkMode ? "#f2f2f2" : Colors.primaryTextColor,
          },
          "& .MuiInputBase-input": {
            fontFamily: "inherit",
            padding: "10px 14px",
          },
          "& .MuiFormHelperText-root": {
            fontFamily: "inherit",
          },
        }}
      />
    </Box>
  );
};

export default InputBox;
